































import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class ConfirmDeleteDialog extends Vue {
	@Prop({ required: false, default: "Stop tracking domain?" })
	public title!: string;

	@Prop({ required: false })
	public bodyText!: string;
}
